const Routes = {
    start: "/",
    users: "/users",
    userViewDefinition: "/user/:id",
    getUserView: (id) => { return "/user/" + id; },
    plants: "/plants",
    addplant: "/plants/add",
    addnewplant: "/plants/addnewplant",
    editplant: "/plants/edit/:id",
    getplantroute: (id) => { return "/plants/edit/" + id },
    plantimages: "/plants/plantimages/:id",
    allplantimages: "/plants/images",
    getplantimagesroute: (id) => { return "/plants/plantimages/" + id },
    createplant: "/plants/createplant",
    planttypes: "/planttypes",
    plantfields: "/plantfields",
    fieldspertype: "/fieldspertype",
    planttags: "/planttags",
    images: "/images",
    listitems: "/misc/listitems",
    colors: "/misc/colors",
    searchfilterseditor: "/misc/searchfilterseditor",
    plantorigins: "/plantorigins",
    gardenactivities: "/activities/gardenactivities",
    onboardinglists: "/onboarding/onboardinglists",
    discover: "/discover",
    gamification: "/gamification",
    plantnetlist: "/plantnetlist",
    systemsettings: "/systemsettings",
    dashboard: "/dashboard",
    toolsscreen: "/toolsscreen",
    snippets: "/misc/snippets",
    tools: "/misc/tools",
    lists: "/misc/lists",
    inspiration: "/inspiration",
    userplants: "/userplants",
    userplantimages: "/userplantimages",
    plantgroups: "/plantgroups",

    plantimageoperations: "/plantimageoperations",
    socialimageoperations: "/socialimageoperations",
    userplantimageoperations: "/userplantimageoperations",
    faq: "/faq",
    feedback: "/feedback",
    forum: "/forum",
    blog: "/blog",
    blogauthors: "/blogauthors",
    webforms: "/webforms",
    postsmanagement: "/postsmanagement",
    userstatus: "/userstatus",
    feed: "/feed",
    comments: "/comments",
    userlists: "/userlists",
    accountsadmin: "/accountsadmin",
    subscriptions: "/subscriptions",
    subscriptionswithoutuser: "/subscriptionswithoutuser",
    purchases: "/purchases",
    createqrcode: "/createqrcode",
    testscreen: "/testscreen",
    // Stats
    statistics: "/statistics/subs",
    signalradmin: "/statistics/admin",
    userstatistics: "/statistics/user",
    citystatistics: "/statistics/citystatistics",
    subscriptionstatistics: "/statistics/subscriptionstatistics",
    miscstatistics: "/statistics/misc",

    adadmin: "/adadmin",
    adclients: "/adclients",
    sponsoredposts: "/sponsoredposts",
    sponsoredpushnotifications: "/sponsoredpushnotifications",
    gamificationads: "/gamificationads",
    combines: "/combines",
    pointofinterests: "/pointofinterests",
    largemap: "/largemap",
    elasticsearchplants: "/elasticsearchplants",
    elasticsearchusers: "/elasticsearchusers",
    elasticsearchblogs: "/elasticsearchblogs",
    elasticsearchposts: "/elasticsearchposts",
    elasticsearchpois: "/elasticsearchpois",
    elasticsearchall: "/elasticsearchall",
    monthlyactivities: "/monthlyactivities",

    organizations: "/organizations",

    getOrganizationsUsers: (id: string) => { return "/organizations/" + id + "/users" },
    organizationsUsers: "/organizations/:id/users",
    getOrganizationsSettings: (id: string) => { return "/organizations/" + id + "/settings" },
    organizationsSettings: "/organizations/:id/settings",
    getOrganizationsBilling: (id: string) => { return "/organizations/" + id + "/billing" },
    organizationsBilling: "/organizations/:id/billing",
}

const Views = {
    start: "start",
    login: "login",
    users: "users",
    userdetail: "userdetail",
    plants: "plants",
    planttags: "planttags",
    addplant: "addplant",
    inspiration: "inspiration",
    planttypes: "planttypes",
    fieldspertype: "fieldspertype",
    images: "images",
    colors: "colors"
};


export { Routes, Views }